import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../../../common/money';
import Date from '../../../../common/date';

export const DateCell = ({ value }) => <Date date={value} />;
DateCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export const DateRangeCell = ({ original }) => (
  <span>
    <Date date={original.fromDate} /> - <Date date={original.toDate} />
  </span>
);
DateRangeCell.propTypes = {
  original: PropTypes.shape({
    fromDate: PropTypes.string.isRequired,
    toDate: PropTypes.string.isRequired,
  }).isRequired,
};

export const MoneyCell = ({ value }) => <Money cents={value} />;
MoneyCell.propTypes = {
  value: PropTypes.number.isRequired,
};
